import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC = () => {
  const { i18n, t } = useTranslation();

  const toggleLanguage = () => {
    const currentLang = i18n.language;
    const newLang = currentLang === 'zh-CN' ? 'en-US' : 'zh-CN';
    i18n.changeLanguage(newLang);
  };

  const currentLang = i18n.language;
  const isChineseMode = currentLang === 'zh-CN';

  return (
    <button
      onClick={toggleLanguage}
      title={t('language.switcher.tooltip')}
      style={{
        backdropFilter: 'blur(10px)',
        border: '0px',
        borderRadius: '50%',
        width: '40px',
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        fontSize: '20px',
        backgroundColor: 'transparent',
        color: 'white'
      }}
      onMouseEnter={(e) => {
        // e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)';
        e.currentTarget.style.transform = 'scale(1.05)';
      }}
      onMouseLeave={(e) => {
        // e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
        e.currentTarget.style.transform = 'scale(1)';
      }}
    >
      {isChineseMode ? '🌐' : '🌍'}
    </button>
  );
};

export default LanguageSwitcher;